/* eslint-disable no-underscore-dangle */
import React, { useState, useEffect } from 'react';
import './tableList.scss';
import axios from 'axios';

// mui table
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button'; // Import Button from @mui/material
import { Link } from 'react-router-dom';

function TableList() {
    const [products, setProducts] = useState([]);
    const [success, setSuccess] = useState("");

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const response = await axios.get(
                    // 'http://localhost:3005/admin/api/products'
                    'https://portal-sanieldanproperties-api.onrender.com/admin/api/products',
                    );
                setProducts(response.data);
            } catch (error) {
                console.error('Error fetching products:', error);
            }
        };

        fetchProducts();
    }, []);


    const handleDelete = async (productId) => {
        console.log(productId)
        try {
            await axios.delete(
                // `http://localhost:3005/admin/delete-product/${productId}`
                `https://portal-sanieldanproperties-api.onrender.com/admin/delete-product/${productId}`,
            );

            // Remove the deleted product from the state
            setProducts(products.filter(product => product._id !== productId));
            setSuccess('Successfully! Deleted');
            setTimeout(() => {
                setSuccess('');
            }, 5000);
        } catch (error) {
            console.error('Error deleting product:', error);
        }
    };


    return (
        <>
         {success && (
        <div
          id="pop-up"
          style={{ zIndex: 9999, borderTopWidth: "6px" }}
          className="fixed border-green-600 shadow-xl bg-white mt-24 xl:mt-28 mr-4 max-w-xs top-0 right-0 py-2 px-3"
        >
          <h2 className="font-bold tracking-wider">Product Deleted</h2>
          <p className="text-sm text-left tracking-wider pt-1">{success}</p>
        </div>
      )}

<TableContainer component={Paper} className="table_list ml-10">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell className="table_cell">Id</TableCell>
                        <TableCell className="table_cell">Title</TableCell>
                        <TableCell className="table_cell">Price</TableCell>
                        <TableCell className="table_cell">Unit Sold</TableCell>
                        <TableCell className="table_cell">Unit Remaining</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {products.length > 0 ? (
                        products.map((row) => (
                        <TableRow key={row._id}>
                            <TableCell component="th" scope="row" className="table_cell"> {row._id}</TableCell>
                            <TableCell className="table_cell">{row.producttitle}</TableCell>
                            <TableCell className="table_cell">N{Number(row.productprice).toLocaleString()}</TableCell>
                            <TableCell className="table_cell">{row.productunitssold}</TableCell>
                            <TableCell className="table_cell">{row.productunitsleft}</TableCell>
                            <div className='flex'>
                            <Link to={`/admin/dashboard/products/${row._id}`}>
                                <Button variant="contained" color="primary">Edit</Button><br/>
                            </Link>
                               <div className='ml-3'>
                               <Button variant="contained" color="secondary" onClick={() => handleDelete(row._id)}>Delete</Button> {/* Delete button */}
                               </div>
                            </div>
                        </TableRow>
                    ))
                ): (
                    <TableRow>
                      <TableCell colSpan={5} align="center">No products found</TableCell>
                    </TableRow>
                  )}
                </TableBody>
            </Table>
        </TableContainer>
        </>

    );
}

export default TableList;
